import { RootState } from 'editor/src/store/index';

const getLayoutSchemas = (state: RootState) => state.editorModules.layouts.schemas;

export default getLayoutSchemas;
